import React from 'react';
import styled from 'styled-components';

export interface TagColors {
  foreground: string;
  background: string;
}

interface Props {
  value: string;
  colors: TagColors;
}

export const RedTag: TagColors = {
  foreground: '#E23636',
  background: '#FCE9E9',
};
export const YellowTag: TagColors = {
  foreground: '#FFA31A',
  background: '#FFF5E5',
};
export const GreenTag: TagColors = {
  foreground: '#31B452',
  background: '#C3EFCE',
};
export const GreyTag: TagColors = {
  foreground: '#262626',
  background: '#E0E0E0',
};

const ColoredTag = styled.div`
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 8px;
  padding-right: 8px;
  width: 70px;
  height: fit-content;
  font-size: 12px;
  border-radius: 8px;
  ${(p: Props) => `color: ${p.colors.foreground};`}
  ${(p: Props) => `background-color: ${p.colors.background};`}
`;

export const TagIndicator: React.FC<Props> = (p: Props) => {
  return <ColoredTag {...p}>{p.value}</ColoredTag>;
};
